import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";

interface MenuItemProps {
  linkTo: string;
  label: string;
  icon: ReactNode;
  onMenuItemClick: () => void;
}

function MenuLinkItem({ linkTo, label, icon, onMenuItemClick }: MenuItemProps) {
  const isExternal = linkTo.startsWith("http");

  return (
    <NavLink
      to={linkTo}
      end={linkTo === "/"}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noreferrer" : undefined}
      onClick={onMenuItemClick}
      className={({ isActive }) =>
        clsx(
          "flex items-center gap-[9px] rounded-lg px-2 py-2 text-[13px] font-medium whitespace-nowrap transition-colors",
          isActive && !isExternal
            ? "bg-brand-soft text-brand"
            : "text-muted hover:bg-surface-2 hover:text-fg"
        )
      }
    >
      <span className="flex h-[17px] w-[17px] flex-none items-center justify-center text-[17px]">
        {icon}
      </span>
      <span className="truncate">{label}</span>
    </NavLink>
  );
}

export default MenuLinkItem;
